var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.493 6.52l-.413-3.267a.665.665 0 00-.667-.586h-4.146a.675.675 0 00-.667.586l-.36 2.867a.655.655 0 01-.427.533 9.7 9.7 0 00-3.106 1.88l-3.04-1.28a.669.669 0 00-.84.28l-2.08 3.6a.682.682 0 00.186.867l2.627 1.987a9.991 9.991 0 00-.013 4.026h.013L2.933 20a.663.663 0 00-.173.867l2.08 3.6a.668.668 0 00.84.28l3.04-1.28-.013.013c.493.44 1.053.84 1.653 1.187.6.346 1.213.626 1.853.84v-.027l.414 3.267c.013.333.306.586.64.586h4.16a.686.686 0 00.666-.586l.36-2.867c.027-.24.2-.453.427-.533a9.698 9.698 0 003.107-1.88l3.04 1.28a.668.668 0 00.84-.28l2.08-3.6a.663.663 0 00-.174-.867l-2.626-1.987c.28-1.346.28-2.72.013-4.026h-.013l2.6-1.987a.663.663 0 00.173-.867l-2.08-3.6a.669.669 0 00-.84-.28l-3.027 1.28.014-.013c-.494-.44-1.054-.84-1.654-1.187a10.03 10.03 0 00-1.853-.84",
    stroke: "url(#settings_svg__paint0_linear)",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.347 21.333a5.333 5.333 0 100-10.666 5.333 5.333 0 000 10.666z",
    stroke: "url(#settings_svg__paint1_linear)",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "settings_svg__paint0_linear",
    x1: 2.665,
    y1: 29.333,
    x2: 33.446,
    y2: 19.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "settings_svg__paint1_linear",
    x1: 10.013,
    y1: 21.333,
    x2: 22.826,
    y2: 16.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })))));
}

export default SvgSettings;